export function initializeJqueryPlugin({ source, isInitialized, afterInitialize }) {
    const initializePlugin = new Function(
        'window',
        'jQuery',
        `
            var module;
            var exports;
            var define;

            ${source}

            return jQuery;
        `
    );

    if (!isInitialized()) {
        initializePlugin(window, window.jQuery);
    }

    if (typeof afterInitialize === 'function') {
        afterInitialize();
    }

    return initializePlugin;
}
